import {usePriceList} from "./components/Providers/PriceListProvider";

var sprintf = require('sprintf-js').sprintf;


export const formatCurrency = (price) => {
  const formatString = window.NTLF_CONFIG.portal.currency.formatString;
  return sprintf(formatString, price);
}

export const formatFullDate = (epoch) => {
  const date = new Date(0)
  date.setUTCSeconds(epoch)
  return date.toLocaleDateString();
}

export const epochToYear = (epoch) => {
  const date = new Date(0)
  date.setUTCSeconds(epoch)
  return date.getFullYear();
}

export const supportMobileTemplates = () => {
  return true;

  // This was used during rollout
  //return !!window.NTLF_CONFIG.portal.options.enable_mobile_version_templates;
}

export const sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  })
}

export const cmToInches = (cm, roundToHalf) => {
  let inches = cm * 0.393700787;
  if (roundToHalf) {
    inches = Math.round(inches * 2) / 2;
  }
  return inches;
}

export const suspendResource = (promise) => {
  let status = "loading"
  let result;
  let suspender = promise.then(
      (data) => {
        status = "success"
        result = data
      },
      (error) => {
        status = "error"
        result = error
      }
  )

  return {
    read() {
      if (status === "loading") {
        throw suspender
      } else if (status === "error") {
        throw result
      } else if (status === "success") {
        return result
      }
    },
  }
}


export const calculateCropRect = (positionInfo, imageSize, containerSize) => {
  let cropRect = {};

  const imageScale = imageSize.width / positionInfo.width;
  console.log('calculateCropRect Image scale', positionInfo, imageScale, containerSize, imageSize);
  if (positionInfo.y > 0) {
    cropRect.top = 0;
    cropRect.height = positionInfo.height * imageScale;
  }
  else {
    cropRect.top = Math.abs(positionInfo.y) * imageScale
    cropRect.height = containerSize.height * imageScale
  }

  if (positionInfo.x > 0) {
    cropRect.left = 0;
    cropRect.width = positionInfo.width * imageScale;
  }
  else {
    cropRect.left = Math.abs(positionInfo.x * imageScale)
    console.log('calculateCropRect width', containerSize.width, imageSize.width, containerSize.width * imageScale);
    cropRect.width = containerSize.width * imageScale;
  }


  // Fix rounding errors:
  const [roundX, roundWidth] = getRoundedValues(parseInt(cropRect.left), parseInt(cropRect.width), imageSize.width);
  const [roundY, roundHeight] = getRoundedValues(parseInt(cropRect.top), parseInt(cropRect.height), imageSize.height);

  const roundedCropRect = {
    left: roundX,
    top: roundY,
    x: roundX,
    y: roundY,
    width: roundWidth,
    height: roundHeight
  }

  console.log('calculateCropRect output', cropRect, roundedCropRect, imageScale, imageSize);


  return roundedCropRect;
}

export const getCropRectFillInByProduct = (imageSize, product, whiteBorder, forceOrientation) => {

  console.log('FFS', imageSize, product)
  let paperWidth = parseInt(product.printareasize[0]);
  let paperHeight = parseInt(product.printareasize[1]);

  // We might change the size, which change ratio:
  if (whiteBorder) {
    // is it 5% of the width? Or?
    let w = Math.min(paperWidth, paperHeight)*0.05;
    paperWidth -= (w*2);
    paperHeight -= (w*2);
  }

  console.log(`The paper size input ${paperWidth}x${paperHeight}`)
  const imageAngle = Math.atan(imageSize.width / imageSize.height);
  const paperAngle1 = Math.atan(paperWidth / paperHeight);
  const paperAngle2 = Math.atan(paperHeight / paperWidth)

  let flip = false;
  if (forceOrientation) {
    if (forceOrientation === 'landscape' && paperWidth < paperHeight) {
      flip = true;
    }
    if (forceOrientation === 'portrait' && paperWidth > paperHeight) {
      flip = true;
    }
  }
  else if (Math.abs(imageAngle - paperAngle1) > Math.abs(imageAngle - paperAngle2)) {
    flip = true;
  }

  if (flip) {
    console.log(`The paper size - Flip ${forceOrientation}`);
    const t = paperWidth;
    paperWidth = paperHeight;
    paperHeight = t;
  }

  console.log(`The paper size${paperWidth}x${paperHeight}`)

  const pos = getBoxSize('fill-in', imageSize, {width: paperWidth, height: paperHeight});

  const d = calculateCropRect(pos, imageSize, {width: paperWidth, height: paperHeight})

  return d;

}

function getRoundedValues(pos, size, sourceSize) {
  while (pos + size > sourceSize) {
    // We can't have crop rect bigger than image size, so reset:
    if (size > sourceSize) {
      pos = 0;
      size = sourceSize;
      console.log('calculateCropRect: Resetting crop size')
    }
    // Reduce size first?
    else if (pos + size > sourceSize) {
      console.log('calculateCropRect: Reducing crop size', (pos + size), sourceSize)
      size--;
    }
  }
  return [pos, size];
}

export const cropRectToImagePosition = (cropRect, imageSize, containerSize, adaption) => {
  if (adaption == 'fit-in') {
    return cropRectToImagePositionFitIn(cropRect, imageSize, containerSize)
  }
  return cropRectToImagePositionFillIn(cropRect, imageSize, containerSize)
}

export const cropRectToImagePositionFillIn = (cropRect, imageSize, containerSize) => {

  const position = getBoxSize('fill-in', cropRect, containerSize);

  console.log('cropRectToImagePositionCropFillIn to rect', cropRect, containerSize, position);

  if (typeof(cropRect.x) == 'undefined') {
    cropRect.x = cropRect.left;
  }
  if (typeof(cropRect.y) == 'undefined') {
    cropRect.y = cropRect.top;
  }

  let diff = cropRect.width / position.width;
  console.log('cropRectToImagePositionCropFillIn to rect', cropRect.x, diff);
  let y = -cropRect.y / diff;
  let x = -cropRect.x / diff;
  let width = imageSize.width / diff;
  let height = imageSize.height / diff;

  if (Math.ceil(position.height) < containerSize.height) {
    console.log('cropRectToImagePositionCropFillIn, height < container', Math.ceil(position.height), containerSize.height)
    // Let's use width as scale factor:
    diff = cropRect.width / position.width;
    width = imageSize.width / diff;
    height = imageSize.height / diff;
    x = -cropRect.x / diff;
    y = -cropRect.y / diff;
    if (cropRect.y == 0) {
      y = (containerSize.height / 2) - (height /2)
    }
  }

  if (Math.ceil(position.width) < containerSize.width) {
    console.log('cropRectToImagePositionCropFillIn, width < container', Math.ceil(position.width), containerSize.width)
    // Let's use height as scale factor:
    diff = cropRect.height / position.height;
    height = imageSize.height / diff;
    width = imageSize.width / diff;
    x = -cropRect.x / diff;
    y = -cropRect.y / diff;
    if (cropRect.x == 0) {
      x = (containerSize.width / 2) - (width /2)
    }
  }

  const newPosition = {
    x,
    y,
    width,
    height
  }
  console.log('cropRectToImagePositionCropFillIn: We use the stuff', newPosition, imageSize, cropRect);

  return newPosition;
}

export const cropRectToImagePositionFitIn = (cropRect, imageSize, containerSize) => {
  console.log('cropRectToImagePositionCrop to rect', cropRect, containerSize);

  const position = getBoxSize('fit-in', cropRect, containerSize);

  console.log('cropRectToImagePositionCrop position', position)


  if (typeof(cropRect.x) == 'undefined') {
    cropRect.x = cropRect.left;
  }
  if (typeof(cropRect.y) == 'undefined') {
    cropRect.y = cropRect.top;
  }

  let diff = cropRect.width / position.width;
  let y = -cropRect.y / diff;
  let x = -cropRect.x / diff;
  let width = imageSize.width / diff;
  let height = imageSize.height / diff;

  if (Math.ceil(position.height) < containerSize.height) {
    console.log('We use stuff, height < container', Math.ceil(position.height), containerSize.height)
    // Let's use width as scale factor:
    diff = cropRect.width / position.width;
    width = imageSize.width / diff;
    height = imageSize.height / diff;
    x = -cropRect.x / diff;
    y = -cropRect.y / diff;
    if (cropRect.y == 0) {
      y = (containerSize.height / 2) - (height /2)
    }
  }

  if (Math.ceil(position.width) < containerSize.width) {
    console.log('We use stuff, width < container', Math.ceil(position.width), containerSize.width)
    // Let's use height as scale factor:
    diff = cropRect.height / position.height;
    height = imageSize.height / diff;
    width = imageSize.width / diff;
    x = -cropRect.x / diff;
    y = -cropRect.y / diff;
    if (cropRect.x == 0) {
      x = (containerSize.width / 2) - (width /2)
    }
  }

  const newPosition = {
    x,
    y,
    width,
    height
  }
  console.log('We use the stuff', imageSize, cropRect);

  return newPosition;
}

/**
 * @param {string} fillin
 * @param {{width: number, height: number}} imageSize
 * @param {{width, height}} containerSize
 */
export const getBoxSize = (fillin, imageSize, containerSize)  => {
  let width = 0, height=0, topp=0, diff=0, left;
  const dratio = containerSize.width/containerSize.height;
  const sratio = imageSize.width/imageSize.height;

  if (fillin == "fit-in") {
    if (dratio < sratio) {
      diff = containerSize.width/imageSize.width;
      width = containerSize.width;
      height = diff*imageSize.height;
    } else {
      diff = containerSize.height/imageSize.height;
      height = containerSize.height;
      width = diff*imageSize.width;
    }

    const left = (containerSize.width/2)-(width/2);
    const topp = (containerSize.height/2)-(height/2);

    return {x: left, y: topp, width: width, height:height};
  }
  else {
    console.log('Box', dratio, sratio)
    if (dratio > sratio) {
      diff = containerSize.width/imageSize.width;
      width = containerSize.width;
      height = diff*imageSize.height;
    } else {
      diff = containerSize.height/imageSize.height;
      height = containerSize.height;
      width = diff*imageSize.width;
    }
    left = (containerSize.width/2)-(width/2);
    topp = (containerSize.height/2)-(height/2);

    console.log('Box out', {x: left, y: topp, width: width, height:height})
    return {x: left, y: topp, width: width, height:height};
  }
}

export function sortSubjectPictures(pictures) {
  const defaultSort = (a, b) => {
    console.log('Image', a);
    console.log('Image keywords', a.keywords, b.keywords)
    if (a.keywords.indexOf("favorite") >= 0 && b.keywords.indexOf("favorite") < 0) {
      return -1;
    }
    else if (a.keywords.indexOf("favorite") < 0 && b.keywords.indexOf("favorite") >= 0) {
      return 1;
    }

    // Show group pictures last:
    else if (a.groupPicture && !b.groupPicture) {
      return 1;
    }
    if (!a.groupPicture && b.groupPicture) {
      return -1;
    }

    else if (a.groupFavoritePicture && !b.groupFavoritePicture) {
      return -1;
    }
    if (!a.groupFavoritePicture && b.groupFavoritePicture) {
      return 1;
    }


    // Sort by number of tags (Should really by array of tags):
    else if (a.keywords.length && !b.keywords.length) {
      return -1;
    }
    else if (!a.keywords.length && b.keywords.length) {
      return 1;
    }
    return 0;
  }

  const favorites = pictures.filter(img => img.keywords.indexOf('favorite') >= 0)

  const portraitImages = pictures.filter(
    img =>
      img.size.height > img.size.width &&
      img.keywords.indexOf('favorite') < 0
  )
    .sort(defaultSort)

  const landscapeImages = pictures.filter(
    img =>
      img.size.height <= img.size.width &&
      img.keywords.indexOf('favorite') < 0
  )
    .sort(defaultSort);

  return favorites.concat(portraitImages, landscapeImages);
}

export const stripHTMLFromString = (str) => {
  return str.replace(/(<([^>]+)>)/gi, " ").trim()
}